import React from 'react'
import { Card } from './style'

export default ({ children, isHorizontal, background, shadow, hasTestABCard }) => (
  <Card 
    isHorizontal={isHorizontal} 
    background={background} 
    shadow={shadow} 
    hasTestABCard={hasTestABCard}
  >
    {children}
  </Card>
)
